"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../resources/constants");
var _default = {
  norway: {
    10: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 39,
      from: 'copenhagen',
      to: 'malmo',
      actualDistance: 44
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 39,
      from: 'rotterdam',
      to: 'hague',
      actualDistance: 27
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 39,
      from: 'nice',
      to: 'cannes',
      actualDistance: 33
    }],
    25: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 97,
      from: 'vienna',
      to: 'bratislava',
      actualDistance: 78
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 97,
      from: 'amsterdam',
      to: 'rotterdam',
      actualDistance: 79
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 97,
      from: 'london',
      to: 'brighton',
      actualDistance: 87
    }],
    50: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 195,
      from: 'brussels',
      to: 'amsterdam',
      actualDistance: 212
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 195,
      from: 'bratislava',
      to: 'budapest',
      actualDistance: 200
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 195,
      from: 'vienna',
      to: 'budapest',
      actualDistance: 243
    }],
    100: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 389,
      from: 'london',
      to: 'glasgow',
      actualDistance: 403
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 389,
      from: 'london',
      to: 'brussels',
      actualDistance: 379
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 389,
      from: 'london',
      to: 'paris',
      actualDistance: 464
    }],
    200: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 778,
      from: 'berlin',
      to: 'brussels',
      actualDistance: 764
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 778,
      from: 'cairo',
      to: 'jerusalem',
      actualDistance: 760
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 778,
      from: 'barcelona',
      to: 'nice',
      actualDistance: 662
    }],
    300: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 1167,
      from: 'madrid',
      to: 'paris',
      actualDistance: 1270
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 1167,
      from: 'marrakech',
      to: 'lisbon',
      actualDistance: 1278
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 1167,
      from: 'london',
      to: 'berlin',
      actualDistance: 1113
    }],
    400: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 1556,
      from: 'rome',
      to: 'paris',
      actualDistance: 1432
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 1556,
      from: 'oslo',
      to: 'narvik',
      actualDistance: 1562
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 1556,
      from: 'rome',
      to: 'budapest',
      actualDistance: 1485
    }],
    500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 1946,
      from: 'oslo',
      to: 'vardo',
      actualDistance: 1961
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 1946,
      from: 'prague',
      to: 'athens',
      actualDistance: 2000
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 1946,
      from: 'london',
      to: 'rome',
      actualDistance: 1880
    }],
    750: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 2918,
      from: 'paris',
      to: 'moscow',
      actualDistance: 2852
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 2918,
      from: 'london',
      to: 'moscow',
      actualDistance: 2906
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 2918,
      from: 'istanbul',
      to: 'paris',
      actualDistance: 2805
    }],
    1000: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1000,
      convertedDistance: 3891,
      from: 'new_york',
      to: 'las_vegas',
      actualDistance: 4068
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1000,
      convertedDistance: 3891,
      from: 'lisbon',
      to: 'istanbul',
      actualDistance: 4089
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1000,
      convertedDistance: 3891,
      from: 'tromso',
      to: 'rome',
      actualDistance: 4096
    }],
    1500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1500,
      convertedDistance: 5837,
      from: 'singapore',
      to: 'new_delhi',
      actualDistance: 5943
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1500,
      convertedDistance: 5837,
      from: 'seattle',
      to: 'miami',
      actualDistance: 5531
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1500,
      convertedDistance: 5837,
      from: 'nairobi',
      to: 'cape_town',
      actualDistance: 5552
    }],
    2000: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 7782,
      from: 'tromso',
      to: 'dubai',
      actualDistance: 7899
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 7782,
      from: 'anchorage',
      to: 'new_york',
      actualDistance: 7027
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 7782,
      from: 'vardo',
      to: 'cairo',
      actualDistance: 7610
    }],
    2500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2500,
      convertedDistance: 9728,
      from: 'barcelona',
      to: 'ulaanbaatar',
      actualDistance: 9575
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2500,
      convertedDistance: 9728,
      from: 'moscow',
      to: 'magadan',
      actualDistance: 10300
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2500,
      convertedDistance: 9728,
      from: 'vardo',
      to: 'dubai',
      actualDistance: 9104
    }],
    4000: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 4000,
      convertedDistance: 15564,
      from: 'lisbon',
      to: 'magadan',
      actualDistance: 14934
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 4000,
      convertedDistance: 15564,
      from: 'tromso',
      to: 'cape_town',
      actualDistance: 16086
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 4000,
      convertedDistance: 15564,
      from: 'moscow',
      to: 'cape_town',
      actualDistance: 15412
    }]
  },
  japan: {
    10: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 85,
      from: 'tokyo',
      to: 'hakone',
      actualDistance: 75
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 85,
      from: 'tokyo',
      to: 'tsuru',
      actualDistance: 77
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 85,
      from: 'tokyo',
      to: 'kashima',
      actualDistance: 88
    }],
    25: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 212,
      from: 'tokyo',
      to: 'joetsu',
      actualDistance: 213
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 212,
      from: 'tokyo',
      to: 'hamamatsu',
      actualDistance: 212
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 212,
      from: 'tokyo',
      to: 'aizuwakamatsu',
      actualDistance: 204
    }],
    50: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 424,
      from: 'tokyo',
      to: 'kyoto',
      actualDistance: 368
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 424,
      from: 'tokyo',
      to: 'kobe',
      actualDistance: 428
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 424,
      from: 'tokyo',
      to: 'morioka',
      actualDistance: 466
    }],
    75: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 75,
      convertedDistance: 636,
      from: 'tokyo',
      to: 'izumo',
      actualDistance: 634
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 75,
      convertedDistance: 636,
      from: 'tokyo',
      to: 'imabari',
      actualDistance: 641
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 75,
      convertedDistance: 636,
      from: 'tokyo',
      to: 'hakodate',
      actualDistance: 684
    }],
    100: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 847,
      from: 'tokyo',
      to: 'hiroshima',
      actualDistance: 679
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 847,
      from: 'tokyo',
      to: 'sapporo',
      actualDistance: 835
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 847,
      from: 'tokyo',
      to: 'shimonoseki',
      actualDistance: 826
    }],
    200: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 1695,
      from: 'tokyo',
      to: 'shanghai',
      actualDistance: 1765
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 1695,
      from: 'tokyo',
      to: 'miyakojima',
      actualDistance: 1840
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 1695,
      from: 'tokyo',
      to: 'dalian',
      actualDistance: 1643
    }],
    300: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 2542,
      from: 'tokyo',
      to: 'guam',
      actualDistance: 2526
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 2542,
      from: 'tokyo',
      to: 'hong_kong',
      actualDistance: 2887
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 2542,
      from: 'tokyo',
      to: 'taipei',
      actualDistance: 2101
    }],
    400: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 3390,
      from: 'tokyo',
      to: 'ulaanbaatar',
      actualDistance: 3254
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 3390,
      from: 'tokyo',
      to: 'hanoi',
      actualDistance: 3674
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 3390,
      from: 'tokyo',
      to: 'cebu',
      actualDistance: 3254
    }],
    500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 4237,
      from: 'tokyo',
      to: 'ho_chi_minh_city',
      actualDistance: 4336
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 4237,
      from: 'tokyo',
      to: 'brunei',
      actualDistance: 4323
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 4237,
      from: 'tokyo',
      to: 'bangkok',
      actualDistance: 4614
    }],
    750: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 6356,
      from: 'tokyo',
      to: 'honolulu',
      actualDistance: 6525
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 6356,
      from: 'tokyo',
      to: 'agra',
      actualDistance: 5840
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 6356,
      from: 'tokyo',
      to: 'ayers_rock',
      actualDistance: 6840
    }],
    1000: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1000,
      convertedDistance: 8475,
      from: 'tokyo',
      to: 'melbourne',
      actualDistance: 8200
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1000,
      convertedDistance: 8475,
      from: 'tokyo',
      to: 'san_francisco',
      actualDistance: 8280
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1000,
      convertedDistance: 8475,
      from: 'tokyo',
      to: 'trondheim',
      actualDistance: 8137
    }],
    1500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1500,
      convertedDistance: 12712,
      from: 'tokyo',
      to: 'la_habana',
      actualDistance: 12135
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1500,
      convertedDistance: 12712,
      from: 'tokyo',
      to: 'sahara',
      actualDistance: 12892
    }],
    1700: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 14407,
      from: 'tokyo',
      to: 'antarctica',
      actualDistance: 14692
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 14407,
      from: 'tokyo',
      to: 'quito',
      actualDistance: 14454
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 14407,
      from: 'tokyo',
      to: 'cape_town',
      actualDistance: 14223
    }],
    2200: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2500,
      convertedDistance: 18644,
      from: 'tokyo',
      to: 'rio_de_janeiro',
      actualDistance: 18593
    }]
  },
  united_kingdom: {
    10: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 46,
      from: 'manchester',
      to: 'liverpool',
      actualDistance: 55
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 10,
      convertedDistance: 46,
      from: 'london',
      to: 'luton',
      actualDistance: 55
    }],
    25: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 114,
      from: 'cambridge',
      to: 'oxford',
      actualDistance: 135
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 114,
      from: 'london',
      to: 'cambridge',
      actualDistance: 103
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 25,
      convertedDistance: 114,
      from: 'london',
      to: 'oxford',
      actualDistance: 90
    }],
    50: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 229,
      from: 'london',
      to: 'cardiff',
      actualDistance: 243
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 50,
      convertedDistance: 229,
      from: 'oxford',
      to: 'sheffield',
      actualDistance: 230
    }],
    100: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 458,
      from: 'london',
      to: 'glasgow',
      actualDistance: 408
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 100,
      convertedDistance: 458,
      from: 'london',
      to: 'newcastle_upon_tyne',
      actualDistance: 455
    }],
    200: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 915,
      from: 'london',
      to: 'inverness',
      actualDistance: 914
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 200,
      convertedDistance: 915,
      from: 'inverness',
      to: 'cardiff',
      actualDistance: 892
    }],
    300: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 1373,
      from: 'john_o_groats',
      to: 'lands_end',
      actualDistance: 1348
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 300,
      convertedDistance: 1373,
      from: 'paris',
      to: 'inverness',
      actualDistance: 1353
    }],
    400: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 1831,
      from: 'glasgow',
      to: 'berlin',
      actualDistance: 1732
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 400,
      convertedDistance: 1831,
      from: 'manchester',
      to: 'vienna',
      actualDistance: 1824
    }],
    500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 2288,
      from: 'brighton',
      to: 'lisbon',
      actualDistance: 2225
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 500,
      convertedDistance: 2288,
      from: 'liverpool',
      to: 'rome',
      actualDistance: 2236
    }],
    750: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 3432,
      from: 'cardiff',
      to: 'istanbul',
      actualDistance: 3279
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 3432,
      from: 'sheffield',
      to: 'marrakech',
      actualDistance: 3301
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 750,
      convertedDistance: 3432,
      from: 'newcastle_upon_tyne',
      to: 'moscow',
      actualDistance: 3333
    }],
    1000: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1000,
      convertedDistance: 4577,
      from: 'paris',
      to: 'sahara',
      actualDistance: 4344
    }],
    1500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 1500,
      convertedDistance: 6865,
      from: 'new_york',
      to: 'anchorage',
      actualDistance: 7005
    }],
    2000: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 9153,
      from: 'new_dehli',
      to: 'manchester',
      actualDistance: 9163
    }, {
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2000,
      convertedDistance: 9153,
      from: 'oxford',
      to: 'ulaanbaatar',
      actualDistance: 9165
    }],
    2500: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 2500,
      convertedDistance: 11442,
      from: 'oslo',
      to: 'nairobi',
      actualDistance: 10471
    }],
    4000: [{
      vehicle: 'car',
      category: _constants.CATEGORY.transport,
      transportMethod: 'driving',
      co2kg: 4000,
      convertedDistance: 18307,
      from: 'marrakech',
      to: 'singapore',
      actualDistance: 16269
    }]
  }
};
exports.default = _default;
//# sourceMappingURL=transportLevels.js.map